// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 800px;
  margin: auto;
  background-color: #fff;
  color: #000;
  page-break-inside: avoid;
}

.printable-header {
  text-align: center;
  margin-bottom: 15px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  page-break-after: avoid;
}

.client-info {
  margin-bottom: 10px;
  page-break-after: avoid;
}

.items-table {
  margin-top: 0;
  margin-bottom: 15px;
}

.items-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;
  page-break-inside: auto;
}

.items-table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.items-table td, 
.items-table th {
  padding: 6px;
  border: 1px solid #ddd;
}

.printable-header h1 {
  font-size: 1.6em;
  margin: 0 0 5px 0;
}

section h2 {
  font-size: 1.2em;
  margin-bottom: 8px;
}

@media print {
  .printable-container {
    padding: 10px !important;
  }
  
  .printable-header {
    margin-bottom: 10px !important;
  }
  
  .client-info {
    margin-bottom: 5px !important;
  }
  
  .items-table table {
    font-size: 0.8em !important;
  }
  
  .items-table td, 
  .items-table th {
    padding: 4px !important;
    line-height: 1.2 !important;
  }
  
  thead {
    display: table-header-group;
  }
  
  tfoot {
    display: table-footer-group;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableQuote.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 800px;\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n  page-break-inside: avoid;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 10px;\n  page-break-after: avoid;\n}\n\n.client-info {\n  margin-bottom: 10px;\n  page-break-after: avoid;\n}\n\n.items-table {\n  margin-top: 0;\n  margin-bottom: 15px;\n}\n\n.items-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9em;\n  page-break-inside: auto;\n}\n\n.items-table tr {\n  page-break-inside: avoid;\n  page-break-after: auto;\n}\n\n.items-table td, \n.items-table th {\n  padding: 6px;\n  border: 1px solid #ddd;\n}\n\n.printable-header h1 {\n  font-size: 1.6em;\n  margin: 0 0 5px 0;\n}\n\nsection h2 {\n  font-size: 1.2em;\n  margin-bottom: 8px;\n}\n\n@media print {\n  .printable-container {\n    padding: 10px !important;\n  }\n  \n  .printable-header {\n    margin-bottom: 10px !important;\n  }\n  \n  .client-info {\n    margin-bottom: 5px !important;\n  }\n  \n  .items-table table {\n    font-size: 0.8em !important;\n  }\n  \n  .items-table td, \n  .items-table th {\n    padding: 4px !important;\n    line-height: 1.2 !important;\n  }\n  \n  thead {\n    display: table-header-group;\n  }\n  \n  tfoot {\n    display: table-footer-group;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
